import { render, staticRenderFns } from "./InvoiceDetails_Profit_Summary.vue?vue&type=template&id=39b61df5&"
import script from "./InvoiceDetails_Profit_Summary.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails_Profit_Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports